module.exports = __webpack_public_path__ + "static/img/product_item_bgImg.9f8c4a2e.png";